module.exports = __webpack_public_path__ + "static/st1-9-a0533080131b80565e38f5eaa6499a55.jpg";